import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCompany } from "../../redux/slices/cleverlynkSlice";
import { selectFooterComponent } from "../../redux/slices/landingSlice";
import Footer from "./Footer";

interface ILandingFooter {}

const LandingFooter = (props: ILandingFooter) => {
  const { backgroundColor, color, hidden } = useSelector(selectFooterComponent);
  const company = useSelector(selectCompany);

  const hyperlinks = React.useMemo(() => company?.hyperlinks ?? [], [company]);
  const socials = React.useMemo(() => company?.socials ?? [], [company]);

  return (
    <Footer
      enable={!hidden}
      hyperlinks={hyperlinks}
      socials={socials}
      textColor={color ?? "#000"}
      backgroundColor={backgroundColor ?? "#fff"}
    />
  );
};
export default LandingFooter;
